import { AxiosRequestConfig } from 'axios';
import { apiClient } from 'common/clients/api.client.ts';
import { API_ENDPOINTS } from 'common/constants/api-endpoints.constants.ts';
import { IWalletDataRes } from 'domains/wallet/inrefaces/wallet.interfaces.ts';

export const getWalletDataService = async ({
  reqConfig,
}: {
  reqConfig?: AxiosRequestConfig,
}): Promise<IWalletDataRes> => {
  const url = API_ENDPOINTS.WALLET.WALLET;
  const config = {
    ...reqConfig,
  };
  const res = await apiClient.get<IWalletDataRes>(url, config);

  return res.data;
};
